import $ from 'jquery';

const $searchOverlay = $('.search-overlay');

const $html = $('html');
const $elementsToAddPadding = $('html, .header');


function openSearchOverlay() {
    // ideally should detect the scrollbar width.
    let outerWidth = $(window).outerWidth();
    let innerWidth = $(document.documentElement).innerWidth();

    $searchOverlay.addClass('search-overlay--show');
    $html.addClass('overflow-hidden');
    $elementsToAddPadding.css('padding-right', outerWidth - innerWidth);
    window.requestAnimationFrame(function () {
        $searchOverlay.addClass('search-overlay--visible');
    });
}

function closeSearchOverlay() {
    $searchOverlay.removeClass('search-overlay--visible');
    window.setTimeout(function () {
        $searchOverlay.removeClass('search-overlay--show');
        $html.removeClass('overflow-hidden');
        $elementsToAddPadding.css('padding-right', '');
    }, 300);
}

$('*[data-toggle="search"]').on('click', function (ev) {
    ev.preventDefault();
    if ($searchOverlay.hasClass('search-overlay--show')) {
        closeSearchOverlay();
    } else {
        openSearchOverlay();
    }
});

$('.search-overlay__close').on('click', function (ev) {
    ev.preventDefault();
    closeSearchOverlay();
});
